/**
 * Validação de CNPJ — suporta formato numérico (antigo) e alfanumérico (novo padrão brasileiro).
 *
 * Referência: https://dev.to/valdeirpsr/cnpj-alfanumerico-implemente-a-validacao-do-novo-cnpj-em-seu-projeto-25hg
 *
 * Formato antigo: 12.345.678/0001-95 (14 dígitos)
 * Formato novo:   12.ABC.345/01DE-35 (alfanumérico)
 *
 * Transformação: cada caractere é convertido para (ASCII - 48).
 *   '0'..'9' → 0..9
 *   'A'..'Z' → 17..42
 */
const REGEX_CNPJ_SEM_DV = /^([A-Z\d]){12}\d{2}$/;
const REGEX_REMOVE_MASCARA = /[^A-Z\d]/g;
const TAMANHO_CNPJ_SEM_DV = 12;
const PESOS_DV = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
const VALOR_BASE = 48;

export function CnpjValidator(value) {
    if (value == null || value === '') return true;

    const cnpjSemMascara = value.toString().toUpperCase().replace(REGEX_REMOVE_MASCARA, '');

    if (!REGEX_CNPJ_SEM_DV.test(cnpjSemMascara)) return false;

    let somatorioDV1 = 0;
    let somatorioDV2 = 0;

    for (let i = 0; i < TAMANHO_CNPJ_SEM_DV; i++) {
        const asciiDigito = cnpjSemMascara.charCodeAt(i) - VALOR_BASE;

        somatorioDV1 += asciiDigito * PESOS_DV[i + 1];
        somatorioDV2 += asciiDigito * PESOS_DV[i];
    }

    const dv1 = somatorioDV1 % 11 < 2 ? 0 : 11 - (somatorioDV1 % 11);

    somatorioDV2 += dv1 * PESOS_DV[TAMANHO_CNPJ_SEM_DV];

    const dv2 = somatorioDV2 % 11 < 2 ? 0 : 11 - (somatorioDV2 % 11);
    const dv = `${dv1}${dv2}`;

    return cnpjSemMascara.slice(-2) === dv;
}
